import { defineStore } from 'pinia'
import {LangType} from "~/types/lang";
import {LANG_HE} from "~/config/langCode";
import {usePopup} from "~/store/usePopup";
import {useApply} from "~/store/useApply";
import {useApplyError} from "~/store/useApplyError";
import {IJobInfoByShortlink} from "~/types/api";
import { DirType } from '../types/lang';

interface IApp {
  dir: DirType
  lang: LangType
  apiData: IJobInfoByShortlink | null
}

export const useApp = defineStore('app', {
  state: (): IApp => {
    return {
      dir: 'ltr',
      lang: 'en',
      apiData: null
    }
  },
  actions: {
    async fetchData(data: IJobInfoByShortlink | undefined) {
      const popupStore = usePopup()
      const applyStore = useApply()
      const applyErrorStore = useApplyError()
      if (!data) {
        popupStore.modalError = true
        popupStore.modalText = 'Error fetching data'
        popupStore.open = true
        return
      }
      try {
        this.apiData = data
        const questionLen = this.apiData?.JobsiteQuestions?.length ?? 0
        applyStore.questions = new Array(questionLen).fill(null)
        const gdprLen = this.apiData?.JobInfo.Gdpr.length ?? 0
        applyStore.gdpr = new Array(gdprLen).fill(false)
        applyErrorStore.questions = new Array(questionLen).fill(false)
        applyErrorStore.gdpr = new Array(gdprLen).fill(false)
        if (this.apiData?.JobInfo.LanguageId === LANG_HE) {
          this.lang = 'he'
          this.dir = 'rtl'
        }
      } catch (error) {
        console.log({ fetchDataError: error })
        popupStore.modalError = true
        popupStore.modalText = 'Error fetching data'
        popupStore.open = true
      }
    }
  },
  // getters: {
  //   dir: (state) => {
  //     return state.lang === 'he' ? 'rtl' : 'ltl'
  //   }
  // }
})